import React from "react";
import {
  Box,
  Typography,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Controller } from "react-hook-form";

export default function CitiesAutocomplete({
  control,
  fieldname,
  options,
  label,
  rules,
  required = false,
  loading = false,
  defaultValue = null,
  query,
  disabled = false,
  onSearch, // Callback for search query
}) {
  const combinedRules = required
    ? { ...rules, required: `This field is required` }
    : rules;
  return (
    <Controller
      name={fieldname}
      control={control}
      defaultValue={defaultValue}
      rules={combinedRules}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Box>
            <Typography variant="body1" textAlign="left">
              {label} {required && <span style={{ color: "red" }}>*</span>}
            </Typography>
            <Autocomplete
              size="small"
              disabled={disabled}
              // value={value}
              value={
                // normalize: if value is an object, use it. If it's just an ID, try to find the option.
                typeof value === "object"
                  ? value
                  : options.find((opt) => opt.id === value) || null
              }
              onChange={(event, newValue) => {
                // console.log("onchnage = ", newValue);
                onChange(newValue ? newValue : null);
              }}
              options={options}
              loading={loading}
              noOptionsText={
                query
                  ? loading
                    ? "Searching for cities..."
                    : "No cities found."
                  : "Start typing to search for cities"
              }
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => {
                return option?.id === value?.id;
              }}
              onInputChange={(event, newInputValue) => {
                if (onSearch) {
                  onSearch(newInputValue); // Trigger the search query
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={!!error}
                  helperText={error ? error.message : null}
                  variant="outlined"
                  placeholder={`Search and Select ${label}`}
                  fullWidth
                  disabled={disabled}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>
        );
      }}
    />
  );
}
